import { config } from '../config';

export function requestSessionToken(input, init) {
    const headers = new Headers(init?.headers ?? (typeof input === 'object' ? input.headers : undefined));
    return /^Bearer ([a-f0-9]{64})$/i.exec(headers.get('Authorization') || '')?.[1] || '';
}

export function shouldExpireSession(status, input, sentToken, currentToken) {
    if (status !== 401 || !sentToken || sentToken !== currentToken) return false;
    try {
        const raw = typeof input === 'string' || input instanceof URL ? String(input) : input.url;
        const url = new URL(raw, window.location.href);
        const api = new URL(config.apiBase, window.location.href);
        if (url.origin !== api.origin || !url.pathname.startsWith(api.pathname.replace(/\/$/, '') + '/')) return false;
        return !/\/auth\/(?:login|passkey|inscription)\.php$/.test(url.pathname);
    } catch { return false; }
}
